import React, { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@radix-ui/react-tabs";
import { useLocation, useNavigate } from "react-router-dom";
import { Ticket, User, Users, User2, FolderTree, LayoutDashboard, BookImage, PartyPopper, GalleryThumbnailsIcon } from "lucide-react";
// import { useToast } from "./ToastProvider";
import { DashboardIcon } from "./../assets/icons";
import { useGlobalContext } from "./GlobalContext";

const PageTabs = ({ children }) => {
  const { globalUserVar, isAuthenticated, setIsAuthenticated } = useGlobalContext();
  const location = useLocation();
  const navigate = useNavigate();
  // const { showToast } = useToast();

  // Dynamically determine the active tab based on the current pathname
  const getNavActive = () => {
    const path = location.pathname.split("/")[1];
    return [
      "dashboard",
      "coupons",
      "account-details",
      "interests",
      "categories",
      "billings",
      "vendors",
      "members",
      "media-gallery",
      "events",
      // "events-list"
    ].includes(path)
      ? path === "event" ? "events" : path
      : "dashboard";
  };

  const [navActive, setNavActive] = useState(getNavActive());
  const [role, setRole] = useState("");
  useEffect(() => {
    setNavActive(getNavActive());
    if (isAuthenticated) {
      let userObj = localStorage.getItem('userObj');
      if (userObj != null && userObj !== "") {
        let userJson = JSON.parse(userObj);
        setRole(userJson.role.name)
      }
    }
    // showToast("Tab changed successfully!");
  }, [location, isAuthenticated]);

  return (
    <div className="flex w-full border-b justify-center bg-white  relative pt-[70px]">
      <Tabs value={navActive} className="TabsRoot">
        <TabsList className="TabsList flex gap-4">
          {/* Dashboard Tab */}
          <TabsTrigger
            className={`TabsTrigger h-[60px] font-medium ${navActive === "dashboard" ? "data-[state=active]" : ""
              }`}
            value="dashboard"
            onClick={() => navigate("/dashboard")}
          >
            <div className="flex items-center">
              {/* <img
                src={DashboardIcon}
                alt="Dashboard"
                className="mr-2 h-4 w-4"
              /> */}
              <LayoutDashboard className="mr-2 h-4 w-4" />
              Dashboard
            </div>
          </TabsTrigger>

          <TabsTrigger
            className={`TabsTrigger h-[60px] font-medium ${navActive === "account-details" ? "data-[state=active]" : ""
              }`}
            value="account-details"
            onClick={() => navigate("/account-details")}
          >
            <div className="flex items-center">
              <User className="mr-2 h-4 w-4" />
              Account
            </div>
          </TabsTrigger>

          {/* Coupons Tab */}
          <TabsTrigger
            className={`TabsTrigger h-[60px] font-medium ${navActive === "coupons" ? "data-[state=active]" : ""
              }`}
            value="coupons"
            onClick={() => navigate("/coupons")}
          >
            <div className="flex items-center">
              <Ticket className="mr-2 h-4 w-4" />
              Deals
            </div>
          </TabsTrigger>

          {role === "Admin" && (
            <>
              <TabsTrigger
                className={`TabsTrigger h-[60px] font-medium ${navActive === "vendors" ? "data-[state=active]" : ""
                  }`}
                value="vendors"
                onClick={() => navigate("/vendors")}
              >
                <div className="flex items-center">
                  <Users className="mr-2 h-4 w-4" />
                  Vendors
                </div>
              </TabsTrigger>
              <TabsTrigger
                className={`TabsTrigger h-[60px] font-medium ${navActive === "members" ? "data-[state=active]" : ""
                  }`}
                value="members"
                onClick={() => navigate("/members")}
              >
                <div className="flex items-center">
                  <User2 className="mr-2 h-4 w-4" />
                  Members
                </div>
              </TabsTrigger>
              <TabsTrigger
                className={`TabsTrigger h-[60px] font-medium ${navActive === "categories" ? "data-[state=active]" : ""
                  }`}
                value="categories"
                onClick={() => navigate("/categories")}
              >
                <div className="flex items-center">
                  <FolderTree className="mr-2 h-4 w-4" />
                  Categories
                </div>
              </TabsTrigger>
              <TabsTrigger
                className={`TabsTrigger h-[60px] font-medium ${navActive === "media-gallery" ? "data-[state=active]" : ""
                  }`}
                value="media-gallery"
                onClick={() => navigate("/media-gallery")}
              >
                <div className="flex items-center">
                  <BookImage className="mr-2 h-4 w-4" />
                  Gallery
                </div>
              </TabsTrigger>
              <TabsTrigger
                className={`TabsTrigger h-[60px] font-medium ${navActive === "events" ? "data-[state=active]" : ""
                  }`}
                value="events"
                onClick={() => navigate("/events")}
              >
                <div className="flex items-center">
                  <PartyPopper className="mr-2 h-4 w-4" />
                  Events
                </div>
              </TabsTrigger>
              <div className="hidden">
                <TabsTrigger
                  className={`TabsTrigger h-[60px] font-medium ${navActive === "event-list" ? "data-[state=active]" : ""
                    }`}
                  value="event-list"
                  onClick={() => navigate("/accordion-gallery")}
                >
                  <div className="flex items-center">
                    <GalleryThumbnailsIcon className="mr-2 h-4 w-4" />
                    Gallery
                  </div>
                </TabsTrigger>

              </div>
            </>

          )}

        </TabsList>
      </Tabs>

      {/* Render children if necessary */}
      <div className="mt-4">{children}</div>
    </div>
  );
};

export default PageTabs;
